export default "__VITE_ASSET__95a9fdb1__"